<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('dictionary.extdb')"
    icon="res-custom-data"
    :res-name="detailData.id"
    :actions="params.actions"
    :current-tab="params.windowData.currentTab"
    :tabs="detailTabs"
    :loaded="loaded"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions :options="singleActions" :row="detailData" button-type="link" button-size="small" />
    </template>
    <component :is="currentTab" :id="listId" :res-id="data.id" :data="detailData" :onManager="onManager" resource="jobs" :getParams="getParams" :showSearchbox="false" :showGroupActions="false" :reportSettingId="reportSettingId" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'
import DataList from './DataList'

export default {
  name: 'ReportCustomDataSidepage',
  components: {
    Actions,
    DataList,
  },
  mixins: [SidePageMixin, WindowsMixin],
  data () {
    return {
      associateTypeList: [],
      associateDataList: [],
    }
  },
  computed: {
    detailTabs () {
      return [
        ...this.associateTypeList.map(item => ({ label: item.name, key: item.id })),
        { label: this.$t('compute.text_240'), key: 'event-drawer' },
      ]
    },
    currentTab () {
      return this.params.windowData.currentTab === 'event-drawer' ? 'event-drawer' : 'data-list'
    },
    reportSettingId () {
      if (this.params.windowData.currentTab !== 'event-drawer') {
        return this.params.windowData.currentTab
      }
      return ''
    },
    getParams () {
      if (this.params.windowData.currentTab !== 'event-drawer') {
        return {
          filter: [`ext_resource_type_id.equals(${this.params.windowData.currentTab})`, `parent_id.equals(${this.detailData.id})`],
        }
      }
      return {}
    },
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'event-drawer':
          return 'EventListForResourceTypeSettingSidePage'
        case 'associated-list':
          return 'AssociatedListForResourceTypeSettingSidePage'
        default:
          return ''
      }
    },
  },
  watch: {
    'detailData.id': {
      handler (id) {
        if (id) {
          this.fetchAssociateDataList(id)
        } else {
          this.associateTypeList = []
        }
      },
    },
  },
  created () {
    this.$eM = new this.$Manager('ext_resources', 'v1')
  },
  methods: {
    async fetchAssociateDataList (id) {
      try {
        const { data = {} } = await this.$eM.list({
          params: {
            filter: `parent_id.equals(${id})`,
            scope: this.$store.getters.scope,
          },
        })
        const list = data.data || []
        if (list.length) {
          const associateTypeList = []
          list.map(item => {
            const { resource_type, ext_resource_type_id } = item
            if (!associateTypeList.some(a => a.id === ext_resource_type_id)) {
              associateTypeList.push({ id: ext_resource_type_id, name: resource_type })
            }
          })
          this.associateTypeList = associateTypeList
        }
      } catch (error) {
        throw error
      }
    },
  },
}
</script>
